import { render, staticRenderFns } from "./FlexColumnMod.vue?vue&type=template&id=a1c8fa68"
import script from "./FlexColumnMod.vue?vue&type=script&lang=js"
export * from "./FlexColumnMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports